import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: 'app-custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.scss']
})
export class CustomModalComponent implements OnInit {

  tabIndex: number = 1;
  modalTitle: string = 'Forgot Password';
  
  
  receivedMessageHandler(p: number) {

    if(p == 1){
      this.tabIndex = 1;
    }else if(p == 2){
      this.tabIndex = 2;
    }else if(p == 3){
      this.tabIndex = 3;
    }else if(p == 4){
      this.tabIndex = 4;
    }else if(p == 5){
      this.tabIndex = 5;
    }else{
      this.tabIndex = 1;
    }
  }

  receivedMessageHandlerReset(p: string) {
    if(p == 'OTP Sent'){
      this.modalTitle = "OTP Sent";
    }else if(p == 'Enter OTP'){
      this.modalTitle = "Enter OTP";
    }else if(p == 'Set New Password'){
      this.modalTitle = "Set New Password";
    }
  }

  modalRef?: BsModalRef;
  modalService: any;


  constructor(public bsModalRef: BsModalRef) { }

  cancel() {
    console.log('Modal closed'); // Add a console log to verify if the cancel method is being called
    this.bsModalRef.hide(); // or any other logic to close the modal
  }

  ngOnInit() {
  }

}
